import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DatePikerPageRoutingModule } from './date-piker-routing.module';

import { DatePikerPage } from './date-piker.page';
import { IgxCalendarModule, IgxDialogModule } from "igniteui-angular";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DatePikerPageRoutingModule,
    BrowserAnimationsModule,
    IgxCalendarModule,
    IgxDialogModule,
    BrowserAnimationsModule
  ],
  declarations: [DatePikerPage]
})
export class DatePikerPageModule { }
